// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const DOC_ENT_LOCAL = {
  PurchaseOrder: 'DOC_ENT_LOCAL1',
  OrdemCompra: 'DOC_ENT_LOCAL2',
  Embarque: 'DOC_ENT_LOCAL3',
  Container: 'DOC_ENT_LOCAL4',
  Nacionalizacao: 'DOC_ENT_LOCAL5',
  EntrepostoAduaneiro: 'DOC_ENT_LOCAL6',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    DOC_ENT_LOCAL1: 1,
    DOC_ENT_LOCAL2: 2,
    DOC_ENT_LOCAL3: 3,
    DOC_ENT_LOCAL4: 4,
    DOC_ENT_LOCAL5: 5,
    DOC_ENT_LOCAL6: 6
  }
}
